// Saved view state. `order` is the column order (utils/columns buildColumns).

export function defaultViewState(order) {
  return {
    tab: 'all',
    search: '',
    columnFilters: {},
    textFilters: {},
    sort: null,
    groupBy: 'none',
    density: 'comfortable',
    visibleKeys: order,
  };
}

export function resolveViewState(view, order) {
  return { ...defaultViewState(order), ...view.state, visibleKeys: view.state.visibleKeys ?? order };
}

function normalize(state) {
  const sortEntries = o =>
    Object.entries(o)
      .filter(([, v]) => (Array.isArray(v) ? v.length > 0 : Boolean(v)))
      .map(([k, v]) => [k, Array.isArray(v) ? [...v].sort() : v])
      .sort(([a], [b]) => String(a).localeCompare(String(b)));
  return JSON.stringify({
    ...state,
    search: state.search.trim(),
    columnFilters: sortEntries(state.columnFilters),
    textFilters: sortEntries(state.textFilters),
    visibleKeys: [...state.visibleKeys].sort(),
  });
}

export function viewStateEquals(a, b) {
  return normalize(a) === normalize(b);
}
